import { render, staticRenderFns } from "./CFormGroup.vue?vue&type=template&id=533fc7da&"
import script from "./CFormGroup.vue?vue&type=script&lang=ts&"
export * from "./CFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports